import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class SidebarLeftEvents extends Component {
  @tracked isEventPickerOpened;

  constructor() {
    super(...arguments);
    installDropdown(this, 'isEventPickerOpened');
  }
}
